import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { DatePicker } from "react-advance-jalaali-datepicker";
import Sidebar from "../../../partials/aside/Sidebar";
import helpersTime from "../../../../helpers/time";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import httpService from "../../../../services/httpServices/httpServices";
import typeAmountDiscount from "./type-amount";

function AddDiscount() {
  const [typeAmount, setTypeAmount] = useState(
    typeAmountDiscount.typeAmountString.PRICE
  );
  const [amount, setAmount] = useState(0);
  const [users, setUsers] = useState([]);
  const [usersIDSelectedForUseDiscount, setUsersIDSelectedForUseDiscount] =
    useState([]);

  const [showUsers, setShowUsers] = useState(false);
  const [
    amountMinPriceCategoryUserSitePublisher,
    setAmountMinPriceCategoryUserSitePublisher,
  ] = useState(0);

  const [
    activeMinPriceCategoryUserSitePublisher,
    setActiveMinPriceCategoryUserSitePublisher,
  ] = useState(false);

  const [
    activeMinDayCountCategoryUserSitePublisher,
    setActiveMinDayCountCategoryUserSitePublisher,
  ] = useState(false);

  const [
    activeLimitRateStartDateCategoryUserSitePublisher,
    setActiveLimitRateStartDateCategoryUserSitePublisher,
  ] = useState(false);

  const [
    activeLimitRateEndDateCategoryUserSitePublisher,
    setActiveLimitRateEndDateCategoryUserSitePublisher,
  ] = useState(false);

  const [activeStartDateDiscount, setActiveStartDateDiscount] = useState(false);
  const [activeEndDateDiscount, setActiveEndDateDiscount] = useState(false);
  const [activeCountUseViaUsers, setActiveCountUseViaUsers] = useState(false);

  const [activeWhichUsersCanUseDiscount, setActiveWhichUsersCanUseDiscount] =
    useState(false);

  const [activeLimitCountUseDiscount, setActiveLimitCountUseDiscount] =
    useState(false);

  const [message, setMessage] = useState();
  const history = useHistory();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  useEffect(() => {
    getAllUser();
  }, []);

  const getAllUser = async () => {
    let users = await sendRequestGetAllUser();
    users = users.map((user) => {
      return {
        id: user.usr_id,
        firstname: user.firstname,
        lastname: user.lastname != undefined ? user.lastname : "",
      };
    });
    setUsers(users);
  };

  const sendRequestGetAllUser = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/all",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data.data;
  };

  const generateUserList = () => {
    if (users.length === 0) {
      return;
    }

    return (
      <div className="table-responsive">
        <table className="table table-bordered table-dark tbl-td-white-space table-hover m-0">
          <thead>
            <td>#</td>
            <td>شماره کاربر</td>
            <td>نام کاربر</td>
            <td>انتخاب</td>
          </thead>
          <tbody>
            {users.map((user, index) => {
              return (
                <tr key={user.id}>
                  <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                  <td>{user.id}</td>
                  <td>
                    {user.firstname} {"  "} {user.lastname}{" "}
                  </td>
                  <td>
                    <span>
                      <label className="adl-switch">
                        <input
                          type="checkbox"
                          className="permissions"
                          onChange={(e) => {
                            setUsersIDSelectedForUseDiscount((prevState) => {
                              if (
                                usersIDSelectedForUseDiscount.includes(user.id)
                              ) {
                                const index = prevState.indexOf(user.id);
                                if (index > -1) {
                                  prevState.splice(index, 1);
                                }
                                return [...prevState];
                              }
                              return [...prevState, user.id];
                            });
                          }}
                        />
                        <span className="adl-slider round"></span>
                      </label>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }

    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const inputAmountMinPriceCategoryUserSitePublisherChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }

    setAmountMinPriceCategoryUserSitePublisher(parseInt(number));
  };

  const inputAmountMinPriceCategoryUserSitePublisherBeforeInputHandler = (
    e
  ) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    await addDiscountCampaignBanner(dataForm);
  };

  const addDiscountCampaignBanner = async (dataForm) => {
    const resultSendRequestAddDiscountCampaignBanner =
      await sendRequestAddDiscountCampaignBanner(dataForm);

    if (resultSendRequestAddDiscountCampaignBanner) {
      history.push(`/manage/discount/campaign-banner/all`);
      return;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestAddDiscountCampaignBanner = async (dataForm) => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/discount/manage/banner",
        { ...dataForm },
        headersRequest
      );
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return true;
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
  };

  const getDataForm = () => {
    const discountTitle = document.querySelector("#title").value;

    const discountAmountValue =
      typeAmount === typeAmountDiscount.typeAmountString.PRICE
        ? amount
        : document.querySelector("#amount").value;

    const conditionAmountMinPriceCategoryUserSitePublisher =
      activeMinPriceCategoryUserSitePublisher === false
        ? amountMinPriceCategoryUserSitePublisher
        : "0";

    const conditionMinDayCountCategoryUserSitePublisher =
      activeMinDayCountCategoryUserSitePublisher === false
        ? document.querySelector("#min-day-count-category-user-site-publisher")
            .value
        : "0";

    const conditionStartDateDiscount =
      activeStartDateDiscount === false ? getStartDateDiscount() : "0";

    const conditionEndDateDiscount =
      activeEndDateDiscount === false ? getEndDateDiscount() : "0";

    const conditionRateStartDateCategoryUserSitePublisher =
      activeLimitRateStartDateCategoryUserSitePublisher === false
        ? getRateStartDateCategoryUserSitePublisher()
        : "0";

    const conditionRateEndDateCategoryUserSitePublisher =
      activeLimitRateEndDateCategoryUserSitePublisher === false
        ? getRateEndDateCategoryUserSitePublisher()
        : "0";

    const conditionLimitCountUseDiscount =
      activeLimitCountUseDiscount === false
        ? document.querySelector("#active-limit-count-use-discount").value
        : "0";

    const conditionCountUseViaUsers =
      activeCountUseViaUsers === false
        ? document.querySelector("#active-count-use-via-users").value
        : "0";

    const conditionWhichUsersCanUseDiscount =
      activeWhichUsersCanUseDiscount === true
        ? usersIDSelectedForUseDiscount
        : [];

    const formData = {
      title: discountTitle,
      amount: discountAmountValue + "",
      type_amount:
        typeAmount === typeAmountDiscount.typeAmountString.PRICE ? "1" : "2",
      start_date_discount: conditionStartDateDiscount,
      end_date_discount: conditionEndDateDiscount,
      rate_start_date_category_user_site_publisher:
        conditionRateStartDateCategoryUserSitePublisher,
      rate_end_date_category_user_site_publisher:
        conditionRateEndDateCategoryUserSitePublisher,
      min_price_category_user_site_publisher:
        conditionAmountMinPriceCategoryUserSitePublisher + "",
      min_count_days_category_user_site_publisher:
        conditionMinDayCountCategoryUserSitePublisher,
      max_count_use_discount: conditionLimitCountUseDiscount,
      max_count_use_each_user: conditionCountUseViaUsers,
      users_which_can_use_discount: conditionWhichUsersCanUseDiscount,
    };

    return formData;
  };

  const getStartDateDiscount = () => {
    const startDateDiscount = document.querySelector("#start-date input").value;
    const hourDateDiscount = document.querySelector(
      "#hour-start-date-discount"
    ).value;
    const minuteDateDiscount = document.querySelector(
      "#minute-start-date-discount"
    ).value;

    return (
      startDateDiscount + "_" + hourDateDiscount + ":" + minuteDateDiscount
    );
  };

  const getEndDateDiscount = () => {
    const endDateDiscount = document.querySelector("#end-date input").value;
    const hourEndDateDiscount = document.querySelector(
      "#hour-end-date-discount"
    ).value;
    const minuteEndDateDiscount = document.querySelector(
      "#minute-end-date-discount"
    ).value;

    return (
      endDateDiscount + "_" + hourEndDateDiscount + ":" + minuteEndDateDiscount
    );
  };

  const getRateStartDateCategoryUserSitePublisher = () => {
    const startRateStartDateCategoryUserSitePublisher = document.querySelector(
      "#start-rate-start-date-category-user-site-publisher input"
    ).value;
    const endRateStartDateCategoryUserSitePublisher = document.querySelector(
      "#end-rate-start-date-category-user-site-publisher input"
    ).value;
    return (
      startRateStartDateCategoryUserSitePublisher +
      "_" +
      endRateStartDateCategoryUserSitePublisher
    );
  };

  const getRateEndDateCategoryUserSitePublisher = () => {
    const startRateEndDateCategoryUserSitePublisher = document.querySelector(
      "#start-rate-end-date-category-user-site-publisher input"
    ).value;
    const endRateEndDateCategoryUserSitePublisher = document.querySelector(
      "#end-rate-end-date-category-user-site-publisher input"
    ).value;
    return (
      startRateEndDateCategoryUserSitePublisher +
      "_" +
      endRateEndDateCategoryUserSitePublisher
    );
  };

  return (
    <>
      <Sidebar openItem="manage-discount" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">اضافه کردن کد تخفیف</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-info">
                <p>
                  کد تخفیف در کمپین های بنری , به مبلغ گروه نمایش دهنده اعمال
                  میشود و مبلغ کمپین , مبلغ بیعانه و مبلغ کل نیز تغییر میدهد
                </p>
                <p>
                  به طور مثال کاربری گروه نمایش دهنده دارد با مبلغ{" "}
                  <span className="letter-spacing-finance-number">۱۵۰,۰۰۰</span>
                  ۰ هزار تومان و زمان گروه نمایش دهنده او ۱۳ روزه است
                </p>
                <p>
                  مبلغ کمپین بنری = تعداد روز گروه نمایش دهنده * مبلغ گروه نمایش
                  دهنده
                </p>
                <p>
                  بدون کد تخفیف مبلغ کمپین کاربر مبلغ{" "}
                  <span className="letter-spacing-finance-number">
                    ۱,۹۵۰,۰۰۰
                  </span>{" "}
                  میباشد
                </p>
                <p className="letter-spacing-finance-number">
                  ۱,۹۵۰,۰۰۰ = ۱۵۰,۰۰۰ * ۱۳
                </p>
                <p>مبلغ بیعانه کمپین</p>
                <p className="letter-spacing-finance-number">
                  ۶۰۵,۰۰۰ = ۳ / ۱,۹۵۰,۰۰۰{" "}
                </p>
                <hr />
                <p>
                  در اینجا کد تخفیف ۳۰% , مبلغ گروه نمایش دهنده او را به مبلغ
                  <span className="letter-spacing-finance-number">
                    ۱۰۵,۰۰۰
                  </span>{" "}
                  ‌هزار تومان میرسید و مبلغ کمپین او به مبلغ{" "}
                  <span className="letter-spacing-finance-number px-2">
                    ۱,۳۶۵,۰۰۰
                  </span>
                  تومان میرسد
                </p>
                <p className="letter-spacing-finance-number">
                  ۱۰۵,۰۰۰ = ۱۵۰,۰۰۰ * ۷۰ / ۱۰۰
                </p>
                <p className="letter-spacing-finance-number">
                  ۱,۳۶۵,۰۰۰ = ۱۰۵,۰۰۰ * ۱۳
                </p>
                <p>مبلغ بیعانه کمپین</p>
                <p className="letter-spacing-finance-number">
                  ۴۵۵,۰۰۰ = ۳ / ۱,۳۶۵,۰۰۰
                </p>
              </div>
              <div id="alert-container"></div>
              {messageTag}
              <div className="col-8">
                <form onSubmit={sendForm}>
                  <div className="form-group py-2">
                    <label>عنوان تخفیف</label>
                    <input
                      type="text"
                      id="title"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex align-items-center">
                      <span className="pl-2">
                        <label className="m-0">مقدار تخفیف</label>
                      </span>
                      <span className="bg-warning d-flex p-1 rounded mb-1">
                        <span className="pl-2">مبلغی</span>
                        <span className="d-flex align-items-center ">
                          <input
                            type="radio"
                            className="hover"
                            name="type-price-discount"
                            defaultChecked={true}
                            onClick={(e) => {
                              setTypeAmount(
                                typeAmountDiscount.typeAmountString.PRICE
                              );
                            }}
                            required
                          />
                        </span>
                        <span className="px-2">درصدی</span>
                        <span className="d-flex align-items-center">
                          <input
                            type="radio"
                            className="hover"
                            name="type-price-discount"
                            onClick={(e) => {
                              setTypeAmount(
                                typeAmountDiscount.typeAmountString.PERCENT
                              );
                            }}
                          />
                        </span>
                      </span>
                    </div>
                    <div>
                      {typeAmount ===
                      typeAmountDiscount.typeAmountString.PRICE ? (
                        <div className="input-group">
                          <input
                            type="text"
                            id="amount"
                            className="form-control number-finance"
                            value={helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(amount)
                            )}
                            onChange={inputAmountChangeHandler}
                            onBeforeInput={inputAmountBeforeInputHandler}
                            dir="ltr"
                            required
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">تومان</span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {typeAmount ===
                      typeAmountDiscount.typeAmountString.PERCENT ? (
                        <div className="input-group">
                          <input
                            type="number"
                            min="1"
                            max="99"
                            id="amount"
                            className="form-control number-finance"
                            dir="ltr"
                            required
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">٪</span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex py-2">
                      <label className="m-0">
                        شرط حداقل مبلغ گروه نمایش دهنده برای تخفیف
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  setActiveMinPriceCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group">
                      <input
                        type="text"
                        id="min-price-category-user-site-publisher"
                        className="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(
                            amountMinPriceCategoryUserSitePublisher
                          )
                        )}
                        onChange={
                          inputAmountMinPriceCategoryUserSitePublisherChangeHandler
                        }
                        onBeforeInput={
                          inputAmountMinPriceCategoryUserSitePublisherBeforeInputHandler
                        }
                        dir="ltr"
                        disabled={activeMinPriceCategoryUserSitePublisher}
                        required
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">تومان</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex pb-2">
                      <label>شرط حداقل تعداد روز نمایش</label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  setActiveMinDayCountCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <input
                      type="number"
                      className="form-control"
                      id="min-day-count-category-user-site-publisher"
                      disabled={activeMinDayCountCategoryUserSitePublisher}
                      required
                    />
                  </div>
                  <div className="form-group py-2">
                    <div>
                      <div className="d-flex">
                        <label className="text-nowrap">
                          شرط تاریخ و ساعت شروع استفاده از کد تخفیف (ساعت را ۲۴
                          ساعته وارد کنید)
                        </label>
                        <div className="d-flex bg-warning  p-1 rounded align-self-start">
                          <div className="text-nowrap pr-2">
                            غیرفعال کردن شرط
                          </div>
                          <div className="pr-2">
                            <span>
                              <label className="adl-switch">
                                <input
                                  type="checkbox"
                                  onChange={(e) => {
                                    setActiveStartDateDiscount(
                                      (prevState) => !prevState
                                    );
                                  }}
                                />
                                <span className="adl-slider round"></span>
                              </label>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        id="start-date"
                        className={`custom-data-picker ${
                          activeStartDateDiscount === true ? "d-none" : ""
                        } `}
                      >
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            moment(helpersTime.getDateNow()).format("YYYY/M/D")
                          )}
                        />
                      </div>
                      <div className="text-nowrap pr-2">ساعت :</div>
                      <div className="px-2">
                        <input
                          className="form-control"
                          type="number"
                          id="hour-start-date-discount"
                          min="0"
                          max="23"
                          disabled={activeStartDateDiscount}
                          required
                        />
                      </div>
                      <div className="text-nowrap">دقیقه :</div>
                      <div className="pr-2">
                        <input
                          className="form-control"
                          type="number"
                          id="minute-start-date-discount"
                          min="0"
                          max="59"
                          disabled={activeStartDateDiscount}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="text-nowrap">
                        شرط تاریخ و ساعت پایان استفاده از کد تخفیف (ساعت را ۲۴
                        ساعته وارد کنید)
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  setActiveEndDateDiscount(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        id="end-date"
                        className={`custom-data-picker ${
                          activeEndDateDiscount === true ? "d-none" : ""
                        } `}
                      >
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            moment(helpersTime.getDateNow(1)).format("YYYY/M/D")
                          )}
                        />
                      </div>
                      <div className="text-nowrap pr-2">ساعت :</div>
                      <div className="px-2">
                        <input
                          className="form-control"
                          type="number"
                          id="hour-end-date-discount"
                          min="0"
                          max="23"
                          disabled={activeEndDateDiscount}
                          required
                        />
                      </div>
                      <div className="text-nowrap">دقیقه :</div>
                      <div className="pr-2">
                        <input
                          className="form-control"
                          type="number"
                          id="minute-end-date-discount"
                          min="0"
                          max="59"
                          disabled={activeEndDateDiscount}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="text-nowrap">
                        شرط بازه تاریخ شروع گروه نمایش دهنده
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  setActiveLimitRateStartDateCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center pt-2">
                      <div>
                        <label>ابتدا بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="start-rate-start-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          activeLimitRateStartDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            moment(helpersTime.getDateNow(1)).format("YYYY/M/D")
                          )}
                        />
                      </div>
                      <div className="pr-2">
                        <label> انتها بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="end-rate-start-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          activeLimitRateStartDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            moment(helpersTime.getDateNow(1)).format("YYYY/M/D")
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="text-nowrap">
                        شرط بازه تاریخ پایان گروه نمایش دهنده
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  setActiveLimitRateEndDateCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center pt-2">
                      <div>
                        <label>ابتدا بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="start-rate-end-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          activeLimitRateEndDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            moment(helpersTime.getDateNow(1)).format("YYYY/M/D")
                          )}
                        />
                      </div>
                      <div className="pr-2">
                        <label> انتها بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="end-rate-end-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          activeLimitRateEndDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            moment(helpersTime.getDateNow(1)).format("YYYY/M/D")
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex pb-2">
                      <label>شرط محدودیت بیشترین استفاده کد تخفیف</label>
                      <span className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">
                          استفاده کردن به شکل نامحدود :
                        </div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  setActiveLimitCountUseDiscount(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </span>
                    </div>
                    <input
                      type="number"
                      id="active-limit-count-use-discount"
                      className="form-control"
                      disabled={activeLimitCountUseDiscount}
                      required
                    />
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex pb-2">
                      <label>
                        شرط محدودیت بیشترین استفاده کد تخفیف هر کاربر
                      </label>

                      <span className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">
                          استفاده کردن به شکل نامحدود :
                        </div>

                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  setActiveCountUseViaUsers(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </span>
                    </div>
                    <input
                      type="number"
                      id="active-count-use-via-users"
                      className="form-control"
                      defaultValue="1"
                      disabled={activeCountUseViaUsers}
                      required
                    />
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="align-self-center m-0">
                        استفاده کاربران از کد تخفیف :
                      </label>
                      <span className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="pr-2">
                          <span>
                            <span className="bg-warning d-flex p-1 rounded mb-1">
                              <span className="pl-2">همه کاربران</span>
                              <span className="d-flex align-items-center ">
                                <input
                                  type="radio"
                                  className="hover"
                                  name="which-user"
                                  defaultChecked={true}
                                  onClick={(e) => {
                                    setActiveWhichUsersCanUseDiscount(false);
                                  }}
                                />
                              </span>
                              <span className="px-2">
                                فقط تعدادی از کاربران
                              </span>
                              <span className="d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="hover"
                                  name="which-user"
                                  onClick={(e) => {
                                    setActiveWhichUsersCanUseDiscount(true);
                                  }}
                                />
                              </span>
                            </span>
                          </span>
                        </div>
                      </span>
                    </div>
                    <div
                      className={`
                      ${
                        activeWhichUsersCanUseDiscount === false ? "d-none" : ""
                      }
                    `}
                    >
                      <div></div>
                      <div
                        className={` ${
                          activeWhichUsersCanUseDiscount === false
                            ? "d-none"
                            : ""
                        }   pt-2   `}
                      >
                        {generateUserList()}
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <button className="btn btn-primary">درج کد تخفیف</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default AddDiscount;
